var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#16242D",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.066 12.5c0 2.321 1.927 4.215 4.289 4.215s4.29-1.894 4.29-4.215-1.928-4.215-4.29-4.215-4.29 1.894-4.29 4.215m1.894 0c0-1.303 1.07-2.354 2.395-2.354 1.326 0 2.395 1.051 2.395 2.354s-1.07 2.354-2.395 2.354c-1.326 0-2.395-1.051-2.395-2.354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.507 14.263C4.3 16.398 7.966 20 12.355 20v-.011c4.378 0 8.055-3.591 9.848-5.737.87-1.03.87-2.475 0-3.515C20.41 8.602 16.744 5 12.355 5S4.3 8.602 2.507 10.748a2.695 2.695 0 0 0 0 3.515m1.46-2.343c1.27-1.522 4.645-5.059 8.388-5.059s7.108 3.537 8.389 5.059c.29.34.29.81 0 1.15-1.27 1.532-4.646 5.069-8.389 5.069s-7.108-3.548-8.389-5.07a.87.87 0 0 1 0-1.15"
  }))));
};
export default SvgEye;